import { Observable } from 'rxjs';

import { Component, OnInit } from '@angular/core';
import { Konto } from '../../../shared/models/konto.model';
import { KontoService } from '../../../@core/http/konto.service';

@Component({
  selector: 'ngx-konto-podglad',
  templateUrl: './konto-podglad.component.html',
  styleUrls: ['./konto-podglad.component.css'],
})
export class KontoPodgladComponent implements OnInit {

  konto$: Observable<Konto>;

  constructor(private readonly kontoService: KontoService) { }

  ngOnInit() {
    this.konto$ = this.kontoService.getKonto();
  }

}
